import React from 'react';
import { DetailWrapper } from 'Screens/Contextualization/Host/components/HostDetail/styled';
import Header from './components/Header';
import Wrapper from 'Screens/Automation/Agents/components/AgentDetail/components/UserAgentDetail/styled';
import Tabs from './components/Tabs';
import Parameters from './components/Sections/Parameters';
import Results from './components/Sections/Results';

const Content = () => {
  const sections = [
    {
      title: 'Parameters',
      element: <Parameters />
    },
    {
      title: 'Results',
      element: <Results />
    }
  ];

  return (
    <DetailWrapper>
        <Wrapper>
          <Header />
          <Tabs sections={ sections } />
        </Wrapper>
    </DetailWrapper>
  );
};

export default Content;
